import {
  Alert,
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import * as React from "react";
import AddIcon from "@mui/icons-material/Add";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import ConfigAndMapDetailsModal from "./ConfigAndMapDetailsModal/ConfigAndMapDetailsModal";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import PriorityHighOutlinedIcon from "@mui/icons-material/PriorityHighOutlined";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import CloseIcon from "@mui/icons-material/Close";
import RemovingMapModal from "./RemovingMapModal/RemovingMapModal";
import AddManualConfigurationModal from "./AddManualConfigurationModal/AddManualConfigurationModal";

const families = [
  {
    title: "Fetcher",
    color: "#607D8B",
    familyName: "Main Family",
    type: "configs",
    items: [
      {
        name: "IA_QCK_After_day",
        count: 19,
        description: "ACIDReport · periodic · none · csv",
        rawData: "raw_data_10132",
        status: "active",
      },
      {
        name: "IA_QCK_none",
        count: 19,
        description: "quicksummaryreport · day_by_day · none · csv",
        rawData: "raw_data_10133",
        status: "pending",
      },
      {
        name: "IA_earning_month",
        count: 19,
        description: "EarningsReport · month_to_date · none · csv",
        rawData: "raw_data_10134",
        status: "inactive",
      },
    ],
  },
  {
    title: "Unifier",
    color: "#E91E63",
    familyName: "Main",
    type: "maps",
    items: [
      {
        name: "ia_brand_per_day_before_TotalBets/Hands _no_Deposits ",
        count: 32,
        description: "daily_user_performance",
        rawData: "",
        status: "active",
      },
      {
        name: "ia_user_per_day_default_no_purchases",
        count: 33,
        description: "daily_user_performance",
        rawData: "",
        status: "active",
      },
    ],
  },
  {
    title: "Advisor",
    color: "#03A9F4",
    familyName: "Affelios Main",
    type: "maps",
    items: [
      // {
      //   name: "affelios_final_daily_brand_performance",
      //   count: 17,
      //   description: "Brand Per Day",
      //   rawData: "",
      //   status: "active",
      // },
      // {
      //   name: "affelios_final_daily_user_performance",
      //   count: 14,
      //   description: "Brand Per User/Day",
      //   rawData: "",
      //   status: "active",
      // },
      // {
      //   name: "affelios_final_monthly_brand_performance",
      //   count: 115,
      //   description: "Brand Per Month",
      //   rawData: "",
      //   status: "active",
      // },
    ],
  },
];

type FamilyCardProps = {
  family: (typeof families)[number];
  handleAddManualConfigurationOpenModal: (
    title: string,
    type: string
  ) => void;
};
function FamilyCard({
  family,
  handleAddManualConfigurationOpenModal,
}: FamilyCardProps) {
  const [openConfigAndMapDetailsModal, setOpenConfigAndMapDetailsModal] =
    React.useState(false);

  const [openModal, setOpenModal] = React.useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleConfigAndMapDetailOpenModal = () => {
    setOpenConfigAndMapDetailsModal(true);
  };
  const handleConfigAndMapDetailCloseModal = () => {
    setOpenConfigAndMapDetailsModal(false);
  };

  return (
    <Box>
      {/* Config / Map Items */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        {family.items.map((item) => (
          <Box
            key={item.name}
            sx={{
              border: "1px solid #0000001F",
              backgroundColor: "#fff",
              borderRadius: "8px",
              p: 1,
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 1,
              minHeight: 58,
              opacity: item.status === "inactive" ? 0.7 : 1,
              filter: item.status === "inactive" ? "grayscale(100%)" : "none",
            }}
          >
            <Box flex={1}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  onClick={handleConfigAndMapDetailOpenModal}
                  component="span"
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#9C27B0",
                    lineHeight: 1.4,
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  {item.name}{" "}
                </Box>
                <Box
                  component="span"
                  sx={{
                    color: "#00000099",
                    fontWeight: 500,
                    fontSize: 14,
                    ml: 0.5,
                  }}
                >
                  ({item.count})
                </Box>
                <Box
                  component="span"
                  sx={{
                    color: "#00000099",
                    fontWeight: 500,
                    fontSize: 14,
                  }}
                >
                  <Alert
                    severity={
                      item.status === "active"
                        ? "success"
                        : item.status === "inactive"
                          ? "error"
                          : "warning"
                    }
                    variant="outlined"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      border: "none",
                      borderRadius: "4px",
                      backgroundColor: "transparent",
                      color:
                        item.status === "active"
                          ? "#2E7D32"
                          : item.status === "inactive"
                            ? "#0000008F"
                            : "#ED6C02",
                      padding: "2px 4px",

                      "& .MuiAlert-icon": {
                        color:
                          item.status === "active"
                            ? "#2E7D32"
                            : item.status === "inactive"
                              ? "#0000008F"
                              : "#ED6C02",
                        fontSize: 15,
                        mr: 0.5,
                        padding: 0,
                        alignItems: "center",
                      },

                      "& .MuiAlert-message": {
                        fontSize: 12,
                        padding: 0,
                      },
                    }}
                    icon={
                      item.status === "active" ? (
                        <DoneOutlinedIcon fontSize="inherit" />
                      ) : item.status === "inactive" ? (
                        <CloseIcon fontSize="inherit" />
                      ) : (
                        <PriorityHighOutlinedIcon fontSize="inherit" />
                      )
                    }
                  >
                    {item.status === "active"
                      ? "Active"
                      : item.status === "inactive"
                        ? "Inactive"
                        : "Pending Save"}
                  </Alert>
                </Box>
              </Box>
              <ConfigAndMapDetailsModal
                open={openConfigAndMapDetailsModal}
                handleClose={handleConfigAndMapDetailCloseModal}
                familyTitle={family.title}
                familyType={family.type}
                familyName={family.items[0].name}
                familyCount={family.items[1].count}
              />

              <Typography
                sx={{
                  fontSize: 12,
                  color: "#00000099",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {family.type === "configs" ? (
                  ""
                ) : (
                  <ArrowForwardOutlinedIcon
                    fontSize="small"
                    sx={{ mr: 0.5, verticalAlign: "middle", fontSize: "15px" }}
                  />
                )}
                {item.description}
              </Typography>

              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#00000099",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.rawData}
              </Typography>
            </Box>
            <Box>
              {item.status !== "inactive" && (
                <IconButton
                  onClick={() => handleAddManualConfigurationOpenModal(family.title, family.type)}
                  size="small"
                  sx={{
                    color: "#9c27b0",
                    mr: 0.5,
                  }}
                >
                  <SwapHorizIcon fontSize="small" />
                </IconButton>
              )}

              {family.type === "configs" ? (
                <IconButton
                  size="small"
                  disabled={item.status === "inactive"}
                  color={
                    item.status === "active"
                      ? "success"
                      : item.status === "inactive"
                        ? "error"
                        : "warning"
                  }
                >
                  <PowerSettingsNewOutlinedIcon fontSize="small" />
                </IconButton>
              ) : (
                <IconButton
                  onClick={handleOpenModal}
                  size="small"
                  color="error"
                >
                  <CloseOutlinedIcon fontSize="small" />
                </IconButton>
              )}
              <RemovingMapModal
                openModal={openModal}
                handleClose={handleCloseModal}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default function AddManualConfiguration() {
  const [openAddManualConfigurationModal, setOpenAddManualConfigurationModal] =
    React.useState(false);
  const [selectedFamilyTitle, setSelectedFamilyTitle] = React.useState("");
  const [selectedFamilyType, setSelectedFamilyType] = React.useState("");
  const handleAddManualConfigurationOpenModal = (
    title: string,
    type: string,
  ) => {
    setOpenAddManualConfigurationModal(true);
    setSelectedFamilyTitle(title);
    setSelectedFamilyType(type);
  };
  const handleAddManualConfigurationCloseModal = () => {
    setOpenAddManualConfigurationModal(false);
    setSelectedFamilyTitle("");
    setSelectedFamilyType("");
  };

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Grid container spacing={2}>
        {families.map((family) => (
          <Grid item xs={12} md={4} key={family.title}>
            {/* Top colored border */}

            <Box
              sx={{
                borderTop: `4px solid ${family.color}`,
                borderRadius: family.items.length === 0 ? "5px" : "5px 5px 0 0",
                backgroundColor: "#fff",
                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
              }}
            >
              {/* Column Header */}
              <Box
                sx={{
                  // height: 65,
                  px: 1,
                  py: 1.5,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #e5e5e5",
                  flexWrap: "wrap",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 500,
                    }}
                  >
                    {family.title}
                  </Typography>

                  {family.items.length === 0 ? (
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 500,
                        mt: 0.5,
                      }}
                    >
                      No Family Found!
                    </Typography>
                  ) : (
                    <Typography
                      sx={{
                        fontSize: 14,
                        mt: 0.5,
                        color: "#00000099",
                      }}
                    >
                      Family:{" "}
                      <span style={{ fontWeight: 500, color: "#000000DE" }}>
                        {" "}
                        IA_no_deposits{" "}
                      </span>{" "}
                      (62)
                    </Typography>
                  )}
                </Box>

                <Typography sx={{ fontSize: 12, color: "#00000099" }}>
                  3 Active {family.type}
                </Typography>
              </Box>

              <Box sx={{ p: 1, background: "#FAFAFA" }}>
                {/* Empty message */}
                {family.items.length === 0 && (
                  <Box
                    width={"100%"}
                    sx={{
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #0000001F",
                      p: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#D32F2F",
                        textAlign: "center",
                      }}
                    >
                      Every Brand needs at least one {family.title}{" "}
                      {family.type}.
                    </Typography>
                  </Box>
                )}

                {/* Family Card */}
                {family.items.length > 0 && (
                  <>
                    <FamilyCard family={family} handleAddManualConfigurationOpenModal={handleAddManualConfigurationOpenModal} />
                  </>
                )}

                <Button
                  onClick={() => handleAddManualConfigurationOpenModal(family.title, family.type)}
                  variant="text"
                  startIcon={<AddIcon />}
                  sx={{
                    color: "#0000008F",
                    fontWeight: 500,
                    fontSize: 13,
                    height: 36,
                    px: 1.4,
                    whiteSpace: "nowrap",
                    mt: 1,
                    textTransform: "Uppercase",

                    "&:hover": {
                      color: "#9C27B0",
                      backgroundColor: "#faf0fc",
                    },
                  }}
                >
                  add{" "}
                  {family.type.endsWith("s")
                    ? family.type.slice(0, -1)
                    : family.type}
                </Button>
                <AddManualConfigurationModal
                  familiesTitle={selectedFamilyTitle}
                  type={selectedFamilyType}
                  openAddManualConfigurationModal={
                    openAddManualConfigurationModal
                  }
                  handleClose={handleAddManualConfigurationCloseModal}
                />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
